import createApiClient from "./api";

const client = createApiClient();

export const dashboardApi = {

  getDashboardStats: () =>
    client.get("/admin/dashboard/stats")
      .then(({ data }) => data),

  getLearnerStatus: () =>
    client.get("/admin/dashboard/learner-status")
      .then(({ data }) => data),

  getCompletionByDepartment: () =>
    client.get("/admin/dashboard/completion-by-department")
      .then(({ data }) => data),

  getRecentLearningPaths: () =>
    client.get("/admin/dashboard/recent-learning-paths")
      .then(({ data }) => data),

  getRecentlyEnrolledLearners: () =>
    client.get("/admin/dashboard/recently-enrolled-learners")
      .then(({ data }) => data),
};